import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Inputs } from "../../../components";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { Commons } from "../../../utilities";
import { PiPlus, PiTrash } from "react-icons/pi";
import { actionPatient } from "../../../redux/actions";

const HealthTracking = ({ loginData, activeTab, tabId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [answersData, setAnswersData] = useState([]);
    const [newAnswers, setNewAnswers] = useState({});
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (
            activeTab === tabId &&
            loginData?.userGuid &&
            loginData?.languageAbb
        ) {
            dispatch(actionPatient.getQuestion1(loginData.languageAbb));
            dispatch(actionPatient.getAnswers1(loginData.userGuid));
        }
    }, [activeTab, loginData.userGuid, loginData.languageAbb, dispatch, tabId]);

    const getQuestionData1 = useSelector(
        (state) => state.patient.getQuestionData1?.data?.result || []
    );
    const getAnswersData1 = useSelector(
        (state) => state.patient.getAnswersData1?.data?.result || []
    );


    const handleInputChange = (e, questionGuid) => {
        const { name, value } = e.target;
        setNewAnswers((prev) => ({
            ...prev,
            [questionGuid]: {
                ...prev[questionGuid],
                [name]: value,
            },
        }));
        setErrors((prev) => ({
            ...prev,
            [questionGuid]: {
                ...prev[questionGuid],
                [name]: "",
            },
        }));
    };

    const handleAdd = (questionGuid, questionType) => {
        const answers = newAnswers[questionGuid] || {};
        const { answer1 = "", answer2 = "" } = answers;

        let newError = {};
        if (!answer1.trim()) newError.answer1 = "* required";
        if (questionType === 2 && !answer2.trim()) newError.answer2 = "* required";

        if (Object.keys(newError).length > 0) {
            setErrors((prev) => ({
                ...prev,
                [questionGuid]: newError,
            }));
            return;
        }

        const maxOrder = answersData
            .filter((ans) => ans.questionGuid === questionGuid)
            .reduce((max, curr) => Math.max(max, curr.answerOrder || 0), 0);

        const newEntry = {
            answerGuid: null,
            questionGuid,
            patientGuid: loginData?.userGuid,
            answer1,
            answer2: questionType === 2 ? answer2 : null,
            answerOrder: maxOrder + 1,
            createdDate: new Date().toISOString(),
        };

        setAnswersData((prev) => [...prev, newEntry]);

        setErrors((prev) => ({
            ...prev,
            [questionGuid]: {},
        }));
        setNewAnswers((prev) => ({
            ...prev,
            [questionGuid]: { answer1: "", answer2: "" },
        }));
    };

    const handleDeleteAnswer = (ans) => {
        setAnswersData((prevData) =>
            prevData.filter((item) => item.answerGuid !== ans.answerGuid)
        );
    };

    const labelMappings = {
        0: {
            label1: t("patient_Details.right_eye"),
            label2: t("patient_Details.left_eye"),
        },
        1: { label1: t("patient_Details.alcohol_intake") },
        2: { label1: t("patient_Details.cigarettes_per_day") },
        3: { label1: t("patient_Details.glucose_level") },
        4: { label1: t("patient_Details.hba1c") },
        5: { label1: t("patient_Details.fasting_glucose") },
        6: { label1: t("patient_Details.pap_smear_result") },
        7: { label1: t("patient_Details.blood_pressure") },
    };

    return (
        <>
            {getQuestionData1.map((que, index) => (
                <div key={index} className="health-info-que-ans-tab-blk">
                    <p className="exado-title-seven health-info-que">{que.question}</p>

                    {que.questionType === 2 && (
                        <div className="health-info-que-input-blk">
                            <Inputs.FormInputs
                                label={errors[que.questionGuid]?.answer1 ? (
                                    <span className="error-message">
                                        {errors[que.questionGuid].answer1}
                                    </span>
                                ) : t("right_eye")}
                                placeholder={que.placeholderText}
                                name="answer1"
                                value={newAnswers[que.questionGuid]?.answer1 || ""}
                                onChange={(e) => handleInputChange(e, que.questionGuid)}
                                grpClassname={`form-group ${errors[que.questionGuid]?.answer1 ? "form-group-error" : ""}`}
                            />
                            <Inputs.FormInputs
                                label={errors[que.questionGuid]?.answer2 ? (
                                    <span className="error-message">
                                        {errors[que.questionGuid].answer2}
                                    </span>
                                ) : t("left_eye")}
                                placeholder={que.placeholderText}
                                name="answer2"
                                value={newAnswers[que.questionGuid]?.answer2 || ""}
                                onChange={(e) => handleInputChange(e, que.questionGuid)}
                                grpClassname={`form-group ${errors[que.questionGuid]?.answer2 ? "form-group-error" : ""}`}
                            />
                        </div>
                    )}

                    {que.questionType === 3 && (
                        <div className="health-info-que-input-blk">
                            <Inputs.FormInputs
                                label={errors[que.questionGuid]?.answer1 ? (
                                    <span className="error-message">
                                        {errors[que.questionGuid].answer1}
                                    </span>
                                ) : t("right_eye")}
                                placeholder={que.placeholderText}
                                name="answer1"
                                value={newAnswers[que.questionGuid]?.answer1 || ""}
                                onChange={(e) => handleInputChange(e, que.questionGuid)}
                                grpClassname={`form-group ${errors[que.questionGuid]?.answer1 ? "form-group-error" : ""}`}
                            />
                        </div>
                    )}

                    <div className="hiqatb-add-new">
                        <span
                            className="custom-cursor-pointer exado_body_text"
                            onClick={() => handleAdd(que.questionGuid, que.questionType)}
                        >
                            {t("doctor.diagnostic_report.add_new")}
                            <PiPlus className="adn-icn exado_body_text" />
                        </span>
                    </div>

                    <p className="exado_body_text past-entries">{t("past_entries")}</p>
                    {getAnswersData1
                        .filter((ans) => ans.questionGuid === que.questionGuid)
                        .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
                        .map((ans, ansIndex) => (
                            <Row key={ansIndex} className="past-entries-data">
                                <Col md={2}>
                                    <span className="past-entries-datalist">
                                        {Commons.formatDateWithOrdinal(new Date(ans.createdDate))}
                                    </span>
                                </Col>
                                <Col md={1}>
                                    <span className="past-entries-datalist">
                                        {new Date(ans.createdDate).toLocaleTimeString("en-US", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        })}
                                    </span>
                                </Col>
                                <Col md={{ span: 2, offset: 2 }}>
                                    <span className="past-entries-datalist">
                                        {labelMappings[index]?.label1 || ""}: {ans.answer1}
                                    </span>
                                </Col>
                                <Col md={2}>
                                    <span className="past-entries-datalist">
                                        {labelMappings[index]?.label2 && (
                                            <>
                                                {labelMappings[index].label2}: {ans.answer2}
                                            </>
                                        )}
                                    </span>
                                </Col>
                                <Col md={{ span: 1, offset: 2 }}>
                                    <PiTrash
                                        className="delIcon noVerify"
                                        onClick={() => handleDeleteAnswer(ans)}
                                    />
                                </Col>
                            </Row>
                        ))}
                </div>
            ))}
        </>
    );
};

export default HealthTracking;
